<template>
  <!-- Page header -->
  <div>
    <div class="page-header page-header-light">
      <div class="page-header-content header-elements-md-inline">
        <div class="page-title d-flex">
          <h4><span class="font-weight-semibold">Engagement stats</span></h4>
        </div>
      </div>
    </div>
    <!-- /page header -->
    <!-- Content area -->
    <div class="content">
      <div class="card">
        <div class="table-responsive" :class="{ 'loading-mask': loading }">
          <div style="float: left; margin-top: 10px">
            <datetime
              type="date"
              :input-class="'form-control'"
              :placeholder="'Choose `from` date'"
              style="margin-left: 20px; float: left; width: 200px"
              v-model="from"
            ></datetime>
            <datetime
              type="date"
              :input-class="'form-control'"
              :placeholder="'Choose `to` date'"
              style="margin-left: 20px; float: left; width: 200px"
              v-model="to"
            ></datetime>
            Filter by number of opens (greater than or equal):
            <input
              placeholder="Filter by number of opens"
              style="border: 1px solid grey; margin-top: 10px; margin: 10px"
              type="number"
              min="1"
              class=""
              v-model="opens_count"
            />
            <button
              @click="analyze"
              class="btn btn-primary pull-right"
              :class="{ disabled: count > 10000 }"
              style="margin: 10px"
            >
              Analyze
            </button>
          </div>
          <table class="table table-striped table-xs" style="min-height: 100px">
            <thead>
              <tr>
                <th>No.</th>
                <th>Generation date</th>
                <th>From</th>
                <th>To</th>
                <th>Count</th>
                <th>Size</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, k) in rows">
                <td style="width: 10px">{{ k + 1 }}</td>
                <td>{{ r.display | formatDate }}</td>
                <td>{{ r.from | formatDate }}</td>
                <td>{{ r.to | formatDate }}</td>
                <td>{{ r.count }}</td>
                <td>{{ r.size | bytes }}</td>
                <td>
                  <button
                    @click="remove($event, r.raw)"
                    class="btn btn-sm btn-danger"
                  >
                    Remove
                  </button>
                  <button
                    @click="downloadCsv($event, r.raw)"
                    class="btn btn-sm btn-primary"
                  >
                    Download CSV
                  </button>
                </td>
              </tr>
              <h2 v-if="rows.length === 0"></h2>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let queryDebounce;
import moment from "moment";
import EventBus from "@/event_bus";
export default {
  data() {
    return {
      showUpload: false,

      from: moment().subtract(14, "day").toISOString(),
      to: moment().toISOString(),

      rows: [],
      loading: true,
      adding: false,
      opens_count: 1,
      limit: 25,
      offset: 0,
      count: 0,
      query: null,
      ready: false,
    };
  },
  watch: {
    query() {
      if (queryDebounce) {
        clearTimeout(queryDebounce);
      }

      queryDebounce = setTimeout(() => {
        this.offset = 0;
        this.load();
      }, 500);
    },
  },
  computed: {
    pages() {
      if (this.count <= this.limit) {
        return 1;
      }

      return Math.ceil(this.count / this.limit);
    },
    page() {
      if (this.offset === 0) {
        return 1;
      }
      return this.offset / this.limit + 1 || 1;
    },
  },
  methods: {
    downloadCsv($event, name) {
      this.$confirm({ message: "Confirm CSV export" }).then(() => {
        let u = this.$api.getUrl() + "campaigns/analyze/csv?name=" + name;

        window.open(u);
        this.$notify.addWarning("Generating CSV please wait...");
      });
    },
    remove($event, name) {
      this.$confirm().then(() => {
        this.$api
          .deleteReq("campaigns/analyze", {
            name: name,
          })
          .then(() => {
            this.$notify.addSuccess("report deleted");
            this.load();
          })
          .catch((err) => {
            this.$notify.addError(err);
          });
      });
    },
    prevPage() {
      this.offset -= 25;
      this.load();
    },
    nextPage() {
      this.offset += 25;
      this.load();
    },
    analyze() {
      this.loading = true;
      this.$api
        .postReq(`campaigns/analyze`, {
          from: moment(this.from).toDate().getTime(),
          to: moment(this.to).toDate().getTime(),
          opens_count: this.opens_count,
        })
        .then((res) => {
          this.loading = false;
          this.ready = false;
        });
    },
    load() {
      this.loading = true;
      this.$api.getReq(`campaigns/analyze`, {}).then((res) => {
        this.loading = false;
        this.rows = res.data.list;
      });
    },
  },
  destroyed() {},
  mounted() {
    this.load();
  },
};
</script>
<style>
.avsquare {
  width: 7px;
  height: 100%;
  float: left;
  cursor: pointer;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}

.avsquare:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.avsquare:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

tbody .btn {
  padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/EngagementStats.vue